import { render, staticRenderFns } from "./ModuleDetailCard.vue?vue&type=template&id=4a56f9ad&"
import script from "./ModuleDetailCard.vue?vue&type=script&lang=ts&"
export * from "./ModuleDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleDetailCard.vue?vue&type=style&index=0&id=4a56f9ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports